import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.general.orderProcessingSettings.title',
    defaultMessage: 'Order processing defaults',
    description: 'title of the order processing settings on the configuration page',
  },
  subtitle: {
    id: 'pages.settings.general.orderProcessingSettings.subtitle',
    defaultMessage: 'Change the default order processing settings',
    description: 'subtitle of the order processing settings on the configuration page',
  },
  feedback: {
    orderProcessingSettingsUpdated: {
      id: 'pages.settings.general.orderProcessingSettings.feedback.orderProcessingSettingsUpdated',
      defaultMessage: 'Order processing saved',
      description: 'feedback on the successful update of order processing settings',
    },
    orderProcessingSettingsNotUpdated: {
      id:
        'pages.settings.general.orderProcessingSettings.feedback.orderProcessingSettingsNotUpdated',
      defaultMessage: 'Order processing could not be saved',
      description: 'feedback on the failed update of order processing settings',
    },
  },
  editDrawer: {
    title: {
      id: 'pages.settings.general.orderProcessingSettings.editDrawer.title',
      defaultMessage: 'Edit order processing defaults',
      description: 'title of the edit order processing drawer',
    },
    allocationField: {
      label: {
        id: 'properties.allocation',
        defaultMessage: 'Allocation',
        description: 'label of the allocation field',
      },
    },
    captureField: {
      label: {
        id: 'properties.capture',
        defaultMessage: 'Capture',
        description: 'label of the capture field',
      },
    },
    confirmField: {
      label: {
        id: 'properties.confirm',
        defaultMessage: 'Confirm',
        description: 'label of the confirm field',
      },
    },
    fulfilmentField: {
      label: {
        id: 'properties.fulfilment',
        defaultMessage: 'Fulfilment',
        description: 'label of the fulfilment field',
      },
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
};

export default defineMessages(translations);
